<template lang="html">
  <payout-form-group :label="$t('Способ подтверждения')" v-if="model"
                     :required="model.isRequiredAttribute(attribute)"
                     :has-errors="model.errors.has(errorsAttribute)">
<!--    <dropdown-keyvalue :options="options"-->
<!--                       :placeholder="$t('Выберите способ подтверждения')"-->
<!--                       :value="model.values.verificationType"-->
<!--                       @input="model.values.verificationType = $event"></dropdown-keyvalue>-->

    <div style="width: 370px;">
      <PrimeDropdown :options="primeOptions"
                     :disabled="disabled"
                     :placeholder="$t('Выберите способ подтверждения')"
                     optionLabel="label"
                     optionValue="value"
                     :value="model.values.verificationType"
                     @input="model.values.verificationType = $event"
      ></PrimeDropdown>
    </div>

    <error-message :attribute="errorsAttribute" :errors="model.errors"></error-message>
  </payout-form-group>
</template>

<script lang="ts">
import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import PayoutFormGroup from '@/components/forms/payout/PayoutFormGroup.vue';
import ErrorMessageBlock from '@/components/forms/payout/ErrorMessageBlock.vue';
import PayoutFormPreloader from '@/components/forms/other/PayoutFormPreloader.vue';
// import DropdownKeyValue from '@/components/forms/dropdown/DropdownKeyValue.vue';
import PrimeDropdown from "@/components/forms/dropdown/themed/PrimeDropdown.vue";
import {PayoutWebModel} from "capitalist-shared/src/finance/payments";
import { VerificationTypes } from "@/models/verification/verification";

@Component({
  components: {
    PrimeDropdown,
    'payout-form-group': PayoutFormGroup,
    'error-message': ErrorMessageBlock,
    'pre-loader': PayoutFormPreloader,
    // 'dropdown-keyvalue': DropdownKeyValue,
  },
  name: 'payout-group-verification-type',
})
export default class PayoutGroupVerificationType extends Vue {
  @Prop({required: true, type: [Object, null, undefined]})
  model!: PayoutWebModel

  @Prop({default: 'verificationType'})
  attribute!: string

  @Prop({default: 'verificationType'})
  errorsAttribute!: string

  @Prop({default: false})
  allowNone: boolean

  get disabled() {
    return this.primeOptions.length === 0;
  }

  get primeOptions() {
    if (!this.model || !this.model?.options?.verification) return [];

    const result = Object.keys(this.model?.options?.verification).map((t) => {
      return {
        value: t,
        label: this.$t(`verification.type.${t}`)
      }
    });

    if (this.allowNone) {
      result.unshift({
        value: VerificationTypes.NONE,
        label: this.$t('verification.type.NONE')
      });
    }

    return result;
  }

  // get options() {
  //   if (!this.model || !this.model?.options?.verification) return {}
  //   const result = {};
  //   Object.keys(this.model?.options?.verification).forEach((t) => {
  //     result[t] = this.$t(`verification.type.${t}`);
  //   })
  //   return result;
  // }
}
</script>

<style scoped lang="less">

</style>


<i18n>
{
  "en": {
    "Способ подтверждения": "Verification type",
    "verification": {
      "type": {
        "OTP": "SMS confirmation",
        "SIGNATURE": "Certificate",
        "TABLECODE": "Code table",
        "NONE": "Without verification",
        "CODE": "By email",
        "PIN": "Payment PIN",
        "GOOGLECODE": "Google 2FA"
      }
    },
    "Выберите способ подтверждения": "Select verification type"
  },
  "ru": {
    "verification": {
      "type": {
        "OTP": "SMS подтверждение",
        "SIGNATURE": "Сертификат",
        "TABLECODE": "Таблица кодов",
        "NONE": "Без верификации",
        "CODE": "По электронной почте",
        "PIN": "Платежный PIN-код",
        "GOOGLECODE": "Google 2FA"
      }
    }
  }
}
</i18n>
